import { SVGProps, Ref, forwardRef } from 'react'
const SvgPeople = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.085 16.071H12.5v-3.214c0-.357-2.142-1.428-3.928-2.143V9.286s.714-.25.714-1.786c.497 0 .714-1.429.023-1.429 0-.151.547-.934.334-1.785-.357-1.429-3.928-1.429-4.285 0C3.854 3.978 5 5.866 5 6.07c-.714 0-.497 1.429 0 1.429 0 1.536.715 1.786.715 1.786v1.428c-1.786.714-3.929 1.786-3.929 2.143v3.214h5.3Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.286 16.071h3.928v-3.214c0-.357-1.786-.857-3.214-1.428v-1.072s.714-.2.714-1.428c.398 0 .553-1.429 0-1.429 0-.12.58-.762.357-1.429C15.714 5 12.857 5 12.5 6.071c-1.204-.246-.357 1.265-.357 1.429-.572 0-.398 1.429 0 1.429 0 1.228.714 1.428.714 1.428v.714"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPeople)
export default ForwardRef
